import { DatePipe, formatNumber } from '@angular/common';
import { Account } from "@app/models/account";
const currencyCode = require('curcode');

export class MethodsHelper {

  private static datePipe: DatePipe = new DatePipe('en-US');

  static haveValue(value) {
    return value !== null && value !== undefined && value !== "";
  }

  static ifHaveNoValue(value, defaultValue) {
    return MethodsHelper.haveValue(value) ? value : defaultValue;
  }

  static numberWithCommas(x) {
    let locale: string = 'en-US';
    return formatNumber(x, locale, '1.2-4')
  }

  static numberWithCommasAllowNull(value) {
    return MethodsHelper.haveValue(value) ? MethodsHelper.numberWithCommas(value) : undefined;
  }

  static amountWithSignInputFieldFocusOut(event): string {
    if (event.target.value) {
      let hasSign = false;
      let amount = event.target.value;

      let sign = amount.charAt(0);

      if (isNaN(parseInt(sign))) {
        amount = amount.substring(1);
        hasSign = true;
      }

      if (amount.indexOf(',') !== -1) {
        if (amount.indexOf('.') === -1) {
          amount = amount.replace(',', '.');
        } else {
          const regex = /[,\s]/g;
          amount = amount.replace(regex, '');
        }
      }
      if (isNaN(Number(amount))) {
        amount = 0;
      }
      amount = parseFloat(amount);
      event.target.value = sign === '-' ? sign + '' + MethodsHelper.numberWithCommas(amount) : MethodsHelper.numberWithCommas(amount);
      return sign === '-' ? sign + '' + amount : amount;
    }
    return '';
  }

  static amountInputFieldFocusOut(value): string {
    if (MethodsHelper.haveValue(value)) {
      let amount = value;

      let sign = amount.charAt(0);

      if (isNaN(parseInt(sign))) {
        amount = amount.substring(1)
      }

      if (amount.indexOf(',') !== -1) {
        if (amount.indexOf('.') === -1) {
          amount = amount.replace(',', '.');
        } else {
          const regex = /[,\s]/g;
          amount = amount.replace(regex, '');
        }
      }
      if (isNaN(Number(amount))) {
        amount = 0;
      }
      amount = parseFloat(amount);
      return MethodsHelper.numberWithCommas(amount);
    }
    return '';
  }

  static amountFieldFocusOut(event): string {
    if (event.target.value) {
      let amount = event.target.value;

      let sign = amount.charAt(0);

      if (isNaN(parseInt(sign))) {
        amount = amount.substring(1)
      }

      if (amount.indexOf(',') !== -1) {
        if (amount.indexOf('.') === -1) {
          amount = amount.replace(',', '.');
        } else {
          const regex = /[,\s]/g;
          amount = amount.replace(regex, '');
        }
      }
      if (isNaN(Number(amount))) {
        amount = 0;
      }
      amount = parseFloat(amount);
      event.target.value = MethodsHelper.numberWithCommas(amount);
      return amount;
    }
    return '';
  }

  static numberWithoutCommas(value) {
    let amount = value;
    if (MethodsHelper.haveValue(amount) && amount.toString().indexOf(',') !== -1) {
      const regex = /[,\s]/g;
      amount = amount.replace(regex, '');
    }
    if (!MethodsHelper.haveValue(amount) || isNaN(Number(amount))) {
      amount = 0;
    }
    return parseFloat(amount);
  }

  static numberWithoutCommasAllowNull(value) {
    return MethodsHelper.haveValue(value) ? MethodsHelper.numberWithoutCommas(value) : undefined;
  }

  static numberWithoutCommasAllowNullInString(value) {
    return MethodsHelper.haveValue(value) ? MethodsHelper.numberWithoutCommas(value).toString() : '';
  }

  static allowAlphanumericOnly(event) {
    const inputChar = String.fromCharCode(event.charCode);
    if (!/^[a-zA-Z0-9]*$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  static onlyAlphanumericSpace(event) {
    const inputChar = String.fromCharCode(event.charCode);
    if (!/^[a-zA-Z0-9 ]*$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  static getCurrencyCode(account: Account): string {
    if (account?.currency) {
      return account.currency.isoCode;
    }
    return "";
  }

  static getYearRange(scope) {
    let startYear = 1900, endYear = 2100;
    let currentYear = (localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date()).getFullYear();
    if (scope < 0) {
      endYear = currentYear;
    } else if (scope > 0) {
      startYear = currentYear;
    }
    return startYear + ":" + endYear;
  }

  static convertToEmpty(value) {
    if (value !== null && value !== undefined && value !== "") {
      return value;
    }
    return "";
  }

  static convertToDate(value): Date {
    if (value) {
      return MethodsHelper.convertToDateFromLocalDatetime(value)
    }
    return localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date();
  }

  static convertToDateFromDDMMYYYY(value): Date {
    if (value) {
      let items = value.split('-');
      if (items.length == 3) {
        return new Date(parseInt(items[2]), parseInt(items[1]) - 1, parseInt(items[0]));
      }
    }

    return localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date();
  }

  static convertDateToString(value: Date) {
    if (value) {
      return (value.getDate() <= 9 ? "0" : "") + value.getDate() + "-" + (value.getMonth() < 9 ? "0" : "") + (value.getMonth() + 1) + "-" + value.getFullYear();
    }

    return "";
  }

  static convertDateToLocalDate(value: Date) {
    if (value) {
      return value.getFullYear() + "-" + (value.getMonth() < 9 ? "0" : "") + (value.getMonth() + 1) + "-" + (value.getDate() <= 9 ? "0" : "") + value.getDate();
    }

    return "";
  }

  static convertDateToLocalDateTime(value: Date) {
    if (value) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, '0');
      const day = String(value.getDate()).padStart(2, '0');
      const hour = String(value.getHours()).padStart(2, '0');
      const minute = String(value.getMinutes()).padStart(2, '0');
      const second = String(value.getSeconds()).padStart(2, '0');
      return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    return "";
  }

  static convertDateToLocalDateTimeWithT(value: Date) {
    if (value) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, '0');
      const day = String(value.getDate()).padStart(2, '0');
      const hour = String(value.getHours()).padStart(2, '0');
      const minute = String(value.getMinutes()).padStart(2, '0');
      const second = String(value.getSeconds()).padStart(2, '0');
      return `${day}-${month}-${year}T${hour}:${minute}:${second}`;
    }
    return "";
  }

  //Convert from dd-mm-yyyy to dd-mm-yyyy
  static convertStringToLocalDate(value: string) {
    const parts = value.split('-');
    return `${parts[0]}-${parts[1]}-${parts[2]}`;
  }

  static findMessageException(ex) {
    let message = "";
    if (ex) {
      if (ex.status == 401 || ex.statusCode == 401) {
        return false
      }
      if (ex.error?.message) {
        message = ex.error.message;
      } else if (ex.message) {
        message = ex.message;
      } else {
        message = ex;
      }
    }

    return message;
  }

  static generateMessageException(ex) {
    let message = "";
    if (ex) {
      if (ex.error?.message) {
        message = ex.error.message;
      } else if (ex.message) {
        message = ex.message;
      } else {
        message = ex;
      }
    }
    return message;
  }

  static findSymbol(code) {
    let item = currencyCode.code(code);
    if (item) {
      return item.symbol;
    }
    return "";
  }

  static downLoadFile(data: any, type: string, fileName: string) {
    let blob = new Blob([data], {type: type});
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    if (fileName) {
      link.download = fileName;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  static getFileName(res) {
    let contentDisposition = res.headers.get('Content-Disposition');
    if (contentDisposition) {
      return contentDisposition.split('filename=')[1].trim().replace(/"/g, '');
    }
    return "";
  }

  static compareDateWithNow(date: any) {
    let currentDate = localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date();
    return new Date(date * 1000) > currentDate;
  }

  /**
   * compare 2 dates
   * return 1 if dateStr1 is greater than dateStr2, -1 if dateStr2 is greater than dateStr1
   * @param dateStr1
   * @param dateStr2
   */
  static compareDates(dateStr1: string, dateStr2: string): number {
    // Parse the date strings into Date objects
    const date1Parts = dateStr1.split('-').map(part => parseInt(part, 10));
    const date2Parts = dateStr2.split('-').map(part => parseInt(part, 10));

    const date1 = new Date(date1Parts[2], date1Parts[1] - 1, date1Parts[0]); // month is 0-indexed
    const date2 = new Date(date2Parts[2], date2Parts[1] - 1, date2Parts[0]); // month is 0-indexed

    // Compare the dates
    if (date1 < date2) {
      return -1;
    } else if (date1 > date2) {
      return 1;
    } else {
      return 0;
    }
  }

  static calculatePeriod = (period: string, currentDate: Date): [start: Date, end: Date] | void => {
    switch (period) {
      case "CURRENT_MONTH":
        return [MethodsHelper.firstDayOfMonth(currentDate), currentDate];
      case "CURRENT_YEAR":
        return [MethodsHelper.firstDayOfYear(currentDate), currentDate];
      case "PREVIOUS_MONTH":
        return [MethodsHelper.firstDayOfPreviousMonth(currentDate), MethodsHelper.lastDayOfPreviousMonth(currentDate)];
      case "PREVIOUS_YEAR":
        return [MethodsHelper.firstDayOfPreviousYear(currentDate), MethodsHelper.lastDayOfPreviousYear(currentDate)];
      case "PREVIOUS_QUARTER":
        return MethodsHelper.calculateQuarter(currentDate);
      default:
        break;
    }
  }

  static calculateQuarter = (currentDate: Date): [start: Date, end: Date] | void => {
    switch (MethodsHelper.getQuarter(currentDate)) {
      case 1:
        return MethodsHelper.fourthQuarter(MethodsHelper.lastDayOfPreviousYear(currentDate));
      case 2:
        return MethodsHelper.firstQuarter(currentDate);
      case 3:
        return MethodsHelper.secondQuarter(currentDate);
      case 4:
        return MethodsHelper.thirdQuarter(currentDate);
      default:
        break;
    }
  }

  static firstDayOfMonth = (date: Date): Date => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  static lastDayOfPreviousMonth = (date: Date): Date => {
    return new Date(date.getFullYear(), date.getMonth(), 0);
  }

  static firstDayOfPreviousMonth = (date: Date): Date => {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  }

  static firstDayOfYear = (date: Date): Date => {
    return new Date(date.getFullYear(), 0, 1);
  }

  static firstDayOfPreviousYear = (date: Date): Date => {
    return new Date(date.getFullYear() - 1, 0, 1);
  }

  static lastDayOfPreviousYear = (date: Date): Date => {
    return new Date(date.getFullYear(), 0, 0);
  }

  static getQuarter = (date = localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date()) => {
    return Math.floor(date.getMonth() / 3 + 1);
  }

  static firstQuarter = (date: Date): [start: Date, end: Date] => {
    return [new Date(date.getFullYear(), 0, 1), new Date(date.getFullYear(), 3, 0)];
  }

  static secondQuarter = (date: Date): [start: Date, end: Date] => {
    return [new Date(date.getFullYear(), 3, 1), new Date(date.getFullYear(), 6, 0)];
  }

  static thirdQuarter = (date: Date): [start: Date, end: Date] => {
    return [new Date(date.getFullYear(), 6, 1), new Date(date.getFullYear(), 9, 0)];
  }

  static fourthQuarter = (date: Date): [start: Date, end: Date] => {
    return [new Date(date.getFullYear(), 9, 1), new Date(date.getFullYear(), 12, 0)];
  }

  static formatNumber(value, pipe) {
    return pipe.transform(value)
  }

  static numberOnly(event: KeyboardEvent): boolean {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    if (
        ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key)
    ) {
      return true;
    }

    // Allow only digits and dot
    if (!/[\d.]/.test(key)) {
      return false;
    }

    const currentValue = input.value;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;

    const nextValue =
        currentValue.slice(0, selectionStart) +
        key +
        currentValue.slice(selectionEnd);

    const parts = nextValue.split('.');

    if (parts.length > 2) {
      return false;
    }
    return !(parts[1] && parts[1].length > 4);
  }

  static isValidJSONString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  /**
   * Convert ISO strings to Date object
   * @param value
   */
  static convertISoStringToDate(value: string) {
    if (value) {
      let date = new Date(value);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }
    return '';
  }

  static convertISoStringToDateOnly(value: string) {
    if (value) {
      let date = new Date(value);
      return date.toLocaleDateString();
    }
    return '';
  }

  static randomString(len) {
    let charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let randomString = '';
    for (let i = 0; i < len; i++) {
      let randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  }

  static getformattedDate() {
    let date = localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date();
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  static validateNumericField(event) {
    if (event.currentTarget.value.length < 15) {
      let charCode = event.charCode;
      return !(charCode > 31 && (charCode < 48 || charCode > 57));
    } else {
      return false;
    }
  }

  static formatNumberWithCommas(value) {
    if (value === null || value === undefined || isNaN(value)) return '';
    return MethodsHelper.numberWithCommas(value);
  }

  static enumToString(value) {
    if (!value) {
      return '';
    }
    const words = value.toLowerCase().split('_');
    const capitalizedWords = words.map(word => {
        if (word === 'for') {
          return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
    );
    return capitalizedWords.join(' ');
  }

  static getUpfrontFee(loan) {
    if (loan) {
      if (loan.upfrontFee) {
        if (MethodsHelper.haveValue(loan.upfrontFeeAmount)) {
          return MethodsHelper.formatNumberWithCommas(loan.upfrontFeeAmount) + " " + loan.currency;
        } else if (MethodsHelper.haveValue(loan.upfrontFeeInterest) || MethodsHelper.haveValue(loan.upfrontFeeMinAmount)) {
          if ((!MethodsHelper.haveValue(loan.upfrontFeeMinAmount) || (loan.upfrontFeeInterest * loan.totalAmount) / 100 > loan.upfrontFeeMinAmount)) {
            return MethodsHelper.formatNumberWithCommas((loan.upfrontFeeInterest * loan.totalAmount) / 100) + " " + loan.currency;
          } else {
            return MethodsHelper.formatNumberWithCommas(loan.upfrontFeeMinAmount) + " " + loan.currency;
          }
        } else if (MethodsHelper.haveValue(loan.upfrontFeeFloatingMinAmount) || MethodsHelper.haveValue(loan.upfrontFeeFloatingMaxAmount)) {
          return MethodsHelper.formatNumberWithCommas(loan.upfrontFeeFloatingMinAmount) + " - " + MethodsHelper.formatNumberWithCommas(loan.upfrontFeeFloatingMaxAmount) + " " + loan.currency;
        }
      } else {
        return 'No';
      }
    }
    return '';
  }

  static getUpfrontServiceFee(loan) {
    if (loan) {
      if (loan.serviceUpfrontFee) {
        if (MethodsHelper.haveValue(loan.serviceUpfrontFeeAmount)) {
          return MethodsHelper.formatNumberWithCommas(loan.serviceUpfrontFeeAmount) + " " + loan.currency;
        } else if (MethodsHelper.haveValue(loan.serviceUpfrontFeeInterest) || MethodsHelper.haveValue(loan.serviceUpfrontFeeMinAmount)) {
          if ((!MethodsHelper.haveValue(loan.serviceUpfrontFeeMinAmount) || (loan.serviceUpfrontFeeInterest * loan.totalAmount) / 100 > loan.serviceUpfrontFeeMinAmount)) {
            return MethodsHelper.formatNumberWithCommas((loan.serviceUpfrontFeeInterest * loan.totalAmount) / 100) + " " + loan.currency;
          } else {
            return MethodsHelper.formatNumberWithCommas(loan.serviceUpfrontFeeMinAmount) + " " + loan.currency;
          }
        } else if (MethodsHelper.haveValue(loan.serviceUpfrontFeeFloatingMinAmount) || MethodsHelper.haveValue(loan.serviceUpfrontFeeFloatingMaxAmount)) {
          return MethodsHelper.formatNumberWithCommas(loan.serviceUpfrontFeeFloatingMinAmount) + " - " + MethodsHelper.formatNumberWithCommas(loan.serviceUpfrontFeeFloatingMaxAmount) + " " + loan.currency;
        }
      } else {
        return 'No';
      }
    }
    return '';
  }

  static getLoanServiceFeeAmount(loan) {
    if (loan) {
      if (loan.serviceFee && loan.serviceFeePaymentType) {
        if (loan.serviceFeeAmount) {
          return MethodsHelper.formatNumberWithCommas(loan.serviceFeeAmount) + " " + loan.currency + ", " + MethodsHelper.capitalize(loan.serviceFeePaymentType);
        } else if (MethodsHelper.haveValue(loan.serviceFeeInterest)) {
          if ((!MethodsHelper.haveValue(loan.serviceFeeMinAmount) || (loan.serviceFeeInterest * loan.totalAmount) / 100 > loan.serviceFeeMinAmount)) {
            return loan.serviceFeeInterest + '% of loan amount' + ", " + MethodsHelper.capitalize(loan.serviceFeePaymentType);
          } else {
            return MethodsHelper.formatNumberWithCommas(loan.serviceFeeMinAmount) + " " + loan.currency + ", " + MethodsHelper.capitalize(loan.serviceFeePaymentType);
          }
        } else if (MethodsHelper.haveValue(loan.serviceFeeOutstandingInterest)) {
          if ((!MethodsHelper.haveValue(loan.serviceFeeMinAmount) || (loan.serviceFeeOutstandingInterest * loan.totalAmount) / 100 > loan.serviceFeeMinAmount)) {
            return loan.serviceFeeOutstandingInterest + '% of loan outstanding amount' + ", " + MethodsHelper.capitalize(loan.serviceFeePaymentType);
          } else {
            return MethodsHelper.formatNumberWithCommas(loan.serviceFeeMinAmount) + " " + loan.currency + ", " + MethodsHelper.capitalize(loan.serviceFeePaymentType);
          }
        }
      } else {
        return 'No'
      }
    }
    return '';
  }

  static getLatePaymentFeePrincipal(loan) {
    if (loan) {
      if (loan.lateRepaymentFeeInterest && loan.lateRepaymentFeeMinAmount) {
        return MethodsHelper.formatNumberWithCommas(loan.lateRepaymentFeeInterest) + "%" + ", " + 'Daily, ' + 'min. amount ' + loan.lateRepaymentFeeMinAmount;
      } else if (loan.lateRepaymentFeeInterest && !loan.lateRepaymentFeeMinAmount) {
        return MethodsHelper.formatNumberWithCommas(loan.lateRepaymentFeeInterest) + "%" + ", " + 'Daily';
      }
      {
        return 'No'
      }
    }
    return '';
  }

  static getLatePaymentFeeInterest(loan) {
    if (loan) {
      if (loan.interestLateRepaymentFeeInterest && loan.interestLateRepaymentFeeMinAmount) {
        return MethodsHelper.formatNumberWithCommas(loan.interestLateRepaymentFeeInterest) + "%" + ", " + 'Daily, ' + 'min. amount ' + loan.interestLateRepaymentFeeMinAmount;
      } else if (loan.interestLateRepaymentFeeInterest && !loan.interestLateRepaymentFeeMinAmount) {
        return MethodsHelper.formatNumberWithCommas(loan.interestLateRepaymentFeeInterest) + "%" + ", " + 'Daily';
      }
      {
        return 'No'
      }
    }
    return '';
  }

  static getLatePaymentFeeServicefee(loan) {
    if (loan) {
      if (loan.serviceFeeLatePaymentFeeInterest && loan.serviceFeeLatePaymentFeeMinAmount) {
        return MethodsHelper.formatNumberWithCommas(loan.serviceFeeLatePaymentFeeInterest) + "%" + ", " + 'Daily, ' + 'min. amount ' + loan.serviceFeeLatePaymentFeeMinAmount;
      } else if (loan.serviceFeeLatePaymentFeeInterest && !loan.serviceFeeLatePaymentFeeMinAmount) {
        return MethodsHelper.formatNumberWithCommas(loan.serviceFeeLatePaymentFeeInterest) + "%" + ", " + 'Daily';
      }
      {
        return 'No'
      }
    }
    return '';
  }

  /**
   * Cut string with size
   * @param size limit of characters
   * @param str modified string
   */
  static stringLimitedSize(size: number, str: string) {
    if (str.length > size) {
      str = str.substr(0, size) + " ...";
    }
    return str;
  }

  /**
   * dividing an array by filter
   * @param array
   * @param predicate
   */
  static divider(array, predicate) {
    return array.reduce((acc, item) => (acc[+!predicate(item)].push(item), acc), [[], []]);
  }

  /**
   * Back format number formatted value
   * @param amount number
   */
  static amountBackFormat(amount) {
    if (amount) {
      if (amount.toString().indexOf(',') !== -1) {
        const regex = /[,\s]/g;
        amount = amount.replace(regex, '');
      }
      if (isNaN(Number(amount))) {
        amount = 0;
      }
      return amount
    }
    return
  }

  static removeValueInArray(array, value) {
    if (array) {
      let index = array.indexOf(value);
      if (index >= 0) {
        array.splice(index, 1);
      }
    }
  }

  /**
   * toString
   * Converts the given date into the string in the following format - yyyy-MM-dd
   *
   * @param date The date which should be formatted
   * @returns formatted date as a String
   */
  static formatDate(date: any) {
    if (date) {
      date = new Date(date);
    }
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 101).toString().slice(-2);
    const day = (date.getDate() + 100).toString().slice(-2);

    return day + '-' + month + '-' + year;
  }

  /**
   * Capitalize given text
   * @param str
   */
  static textCapitalize(str: string | null | undefined) : string{
    if (!str) return '';
    const lower = str.toLowerCase();
    return str.toLowerCase().charAt(0).toUpperCase() + str.toLowerCase().slice(1)
  }

  /**
   * Parsing error message from response object if exist
   * other ways return message
   * @param error
   */
  static showErrorMessageStyling(error) {
  let errorMessage: string | boolean;

  if (error?.error && typeof error.error === "string") {
    const parsedResponse = JSON.parse(error.error);
    errorMessage = parsedResponse?.message ?? '';
  } 
  else if (error?.error && typeof error.error === "object") {
    const parsedResponse = error.error;
    errorMessage = parsedResponse?.message ?? '';
  } 
  else {
    errorMessage = MethodsHelper.findMessageException(error) || '';
  }

  return errorMessage;
}

  static showErrorMessageBlob(error) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function () {
        const result = reader.result as string;
        const jsonData = JSON.parse(result);
        const message = jsonData.message;
        resolve(message);
      };

      reader.onerror = function (event) {
        reject(event.target.error);
      };

      reader.readAsText(error.error);
    });
  }

  static areAllPropertiesEmpty(obj) {
    if (obj) {
      const values = Object.values(obj);
      return values.every(value => value === null || value === undefined || value === '');
    }
    return true;
  }

  static objectToArrayWithKeyAsValueAndValueAsLabel(obj, format = false) {
    const array = [];

    for (const key in obj) {
      const newObject = {
        value: key,
        label: format ? MethodsHelper.formatTitle(obj[key]) : obj[key]
      };

      array.push(newObject);
    }

    return array;
  }

  static formatTitle(value) {
    if (MethodsHelper.haveValue(value)) {
      value = value.replaceAll('_', ' ');
      const words = value.split(' ');
      const uppercasedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      });
      return uppercasedWords.join(' ');
    }
    return "";
  }


  static getDefaultCurrency(currencyService) {
    let defaultCurrency;
    const pageParam = {
      size: 9999,
      page: 0
    }
    let currencies = [];
    currencyService.getList(pageParam).subscribe({
      next: (data) => {
        currencies = data.content.filter((elem) => elem.default === true);
        defaultCurrency = currencies[0].isoCode;
      },
      error: (err) => {
        console.log(MethodsHelper.showErrorMessageStyling(err));
      }
    });
  }

  /**
   *
   * @param arr
   * @param key
   */
  static getConstantValueByKey(arr, key) {
    let val = '';
    for (let i in arr) {
      if (arr[i].value === key) {
        val = arr[i].label;
      }
    }
    return val;
  }

  static getLabelByValue(value: string, labels): string | undefined {
    const customerType = labels.find(type => type.value === value);
    return customerType ? customerType.label : undefined;
  }

  static createDate(date:string){
    const [day, month, year] = date.split('-');
    return new Date(`${day}-${month}-${year}`);
  }

  static convertToDateFromLocalDatetime(datetime: string) {
    const [day, month, year] = datetime.substring(0, 10).split('-');
    return new Date(`${year}-${month}-${day}`);
  }

  static convertToDateFromDateT(datetime: string) {
    const [day, month, year] = datetime.substring(0, 10).split('-');
    return `${day}-${month}-${year}`;
  }

  /**
   * Format date into human-readable format when there is a "T" in date format
   * @param dateTimeString
   */
  static formatDateToLocal(dateTimeString: string | Date): string {
    if (dateTimeString instanceof Date) {
      dateTimeString = dateTimeString.toString();
    }
    const indexOfT = dateTimeString.indexOf('T');
    if (indexOfT !== -1) {
      return dateTimeString.substring(0, indexOfT);
    } else {
      return '';
    }
  }

  static formatDateTimeWithZ(originalTimestamp: string | Date){
    if((typeof originalTimestamp == 'string' && originalTimestamp.indexOf('Z')!== -1) || originalTimestamp.toString().endsWith('Z')){
    const date = new Date(originalTimestamp);
      return `${('0' + date.getUTCDate()).slice(-2)}-${('0' + (date.getUTCMonth() + 1)).slice(-2)}-${date.getUTCFullYear()} ${('0'
          + date.getUTCHours()).slice(-2)}:${('0' + date.getUTCMinutes()).slice(-2)}:${('0' + date.getUTCSeconds()).slice(-2)}`;
    }
    return ''
  }

  static compareStringWithNumber(num1, num2): boolean {
    let isLessOrEqual: boolean = false;
    if (typeof num1 == 'string') {
      const cleanedString = num1.replace(/,/g, '');
      const numericValueFromString = parseFloat(cleanedString);
      isLessOrEqual = numericValueFromString === num2 || numericValueFromString < num2;
    } else {
      isLessOrEqual = (num1 <= num2)
    }
    return isLessOrEqual
  }

  static genNoteRowData(itemNotes: any[], colHeader: string): string {
    const headerNode = itemNotes?.find(note => note.name === colHeader);
    if (!headerNode) return '';

    return this.findLastChild(itemNotes, headerNode.id);
  }

  static findLastChild(notes: any[], parentId: string): string {
    const child = notes.find(note => note.parentId === parentId);
    return child ? this.findLastChild(notes, child.id) || child.name : '';
  }

  static capitalize(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  static convertStringToDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    const parts = dateStr.split('-');
    if (parts.length !== 3) return null;

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    return new Date(year, month, day);
  }

  static toIsoTime(value: any): string {
    if (!value) {
        throw new Error('sendingTime is empty');
    }

    // Case 1: already a Date
    if (value instanceof Date && !isNaN(value.getTime())) {
        return value.toISOString();
    }

    // Case 2: string like "HH:mm"
    if (typeof value === 'string') {
        const date = new Date(`1970-01-01T${value}:00`);
        if (!isNaN(date.getTime())) {
            return date.toISOString();
        }
    }

    throw new Error('Invalid sendingTime format');
}

}

